import React from 'react';
import '../App.css';
import { RingMark, SectionTitle, SiteHeader, SiteFooter, WHATSAPP_LINK } from '../components/Shared';

const PRINCIPIOS = [
  {
    titulo: 'Naturalíssimo',
    texto: '"Usamos as melhores frutas... você estará bebendo um produto com sabor de verdade." Sem corantes, conservantes ou aromatizantes.',
  },
  {
    titulo: 'Praticidade',
    texto: 'Um sachê substitui estoque, mão de obra e picos de demanda. Pronto em minutos, sem complicação.',
  },
  {
    titulo: 'Versatilidade',
    texto: '"Você escolhe": o mesmo sachê vira suco, soda ou drink. A marca nunca fixa um único uso.',
  },
  {
    titulo: 'Consciente',
    texto: 'Açúcar demerara, orgânico — poquíssimo açúcar. Feito pra quem se importa com o que bebe.',
  },
];

const SABORES = [
  { nome: 'Frutas Vermelhas', cor: 'var(--sabor-frutas-vermelhas)' },
  { nome: 'Maracujá com Baunilha', cor: 'var(--sabor-maracuja-baunilha)' },
  { nome: 'Abacaxi com Alecrim', cor: 'var(--sabor-abacaxi-alecrim)' },
  { nome: 'Lima, Limão e Gengibre', cor: 'var(--sabor-lima-limao-gengibre)' },
];

const PASSO_INICIAL = {
  titulo: 'Sachê',
  texto: 'Coloque o sachê em um recipiente com água por ±2 minutos, até descongelar, e abra pelos picotes nas laterais.',
};

const CAMINHOS = [
  {
    liquidoTitulo: 'Água',
    liquido: '200ml de água',
    copo: 'Copo de 300ml',
    resultado: 'Suco',
    mensagem: 'Pronto! Seu suco natural, fresquinho e sem complicação.',
  },
  {
    liquidoTitulo: 'Água gasosa',
    liquido: '200ml de água gasosa',
    copo: 'Copo de 300ml',
    resultado: 'Soda',
    mensagem: 'Pronto! Uma soda refrescante, do jeito que você gosta.',
  },
  {
    liquidoTitulo: 'Base alcoólica',
    liquido: '50ml de bebida alcoólica — gin, vodka, saquê, de sua preferência',
    copo: 'Copo com gelo',
    resultado: 'Drink',
    mensagem: 'Pronto! Seu drink autoral, na medida certa.',
  },
];

function Home() {
  return (
    <div className="App">
      <a className="skip-link" href="#conteudo">Pular pro conteúdo</a>

      <SiteHeader />

      <main id="conteudo">
        <section className="hero">
          <div className="hero__content">
            <h1 className="hero__title">
              Base natural de frutas para <em>sucos, sodas e drinks.</em>
            </h1>
            <p className="hero__lead">
              Ready to Drink é uma bebida 100% natural no formato de sachê, feita com frutas,
              sem álcool, pronta para você usar como base de sodas, sucos ou drinks.
              <strong> Você escolhe!</strong>
            </p>
            <a className="btn btn--primary" href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
              Fazer pedido pelo WhatsApp
            </a>
          </div>
          <div className="hero__visual">
            <RingMark className="hero__ring-watermark" />
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              className="hero__logo"
              alt="ready to drink"
            />
          </div>
        </section>

        <section className="principios">
          <SectionTitle label="Por que Ready to Drink" />
          <div className="principios__grid">
            {PRINCIPIOS.map((p) => (
              <article className="principio-card" key={p.titulo}>
                <span className="principio-card__diamante" aria-hidden="true" />
                <h3 className="principio-card__titulo">{p.titulo}</h3>
                <p className="principio-card__texto">{p.texto}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="sabores">
          <SectionTitle label="Sabores" />
          <div className="sabores__grid">
            {SABORES.map((s) => (
              <div className="sabor-chip" style={{ '--sabor-cor': s.cor }} key={s.nome}>
                <span className="sabor-chip__diamante" aria-hidden="true" />
                <span className="sabor-chip__nome">{s.nome}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="modo-preparo">
          <SectionTitle label="Modo de preparo" />

          <div className="passo passo--inicial">
            <div className="passo__circulo">1</div>
            <h3 className="passo__titulo">{PASSO_INICIAL.titulo}</h3>
            <p className="passo__texto">{PASSO_INICIAL.texto}</p>
          </div>

          <span className="passo-seta passo-seta--down" aria-hidden="true" />

          <div className="caminhos">
            {CAMINHOS.map((c) => (
              <div className="caminho" key={c.resultado}>
                <div className="passo">
                  <div className="passo__circulo">2</div>
                  <h3 className="passo__titulo">{c.liquidoTitulo}</h3>
                  <p className="passo__texto">
                    <strong>{c.liquido}</strong>
                    <br />
                    {c.copo}
                  </p>
                </div>

                <span className="passo-seta passo-seta--down" aria-hidden="true" />

                <div className="passo">
                  <div className="passo__circulo">3</div>
                  <h3 className="passo__titulo">{c.resultado}</h3>
                  <p className="passo__texto">{c.mensagem}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="quem-somos">
          <p>
            A Fragus Alimentos é uma micro indústria localizada na cidade de Belo Horizonte/MG
            que produz uma base <strong>100% natural</strong> no formato de sachê feita com
            frutas, sem álcool, pronta para você utilizar como base de <strong>sodas</strong>,{' '}
            <strong>sucos</strong> ou <strong>drinks</strong>. Você escolhe!
          </p>
        </section>
      </main>

      <SiteFooter>
        <p className="site-footer__contato">
          Para fazer um pedido, entre em contato por WhatsApp pelo número:{' '}
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
            <strong>(31) 98280-5782</strong>
          </a>
        </p>
      </SiteFooter>
    </div>
  );
}

export default Home;
